import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  Form,
} from 'react-bootstrap';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { getMostPopularTales,updateTaleStatus } from '../../api/taleService';
export default function AnalyticsInsights() {  
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // Initially empty, will be populated with API data
  const [analytics, setAnalytics] = useState({
    totalUsersCount: 0,
    newUsersCount: 0,
    talesCreatedCount: 0,
    aiAssistedTalesCount: 0,
    aiGeneratedTalesCount: 0,
  });

  const handleToggleStatus = (id, currentStatus) => {
    const updatedStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';
    updateTaleStatus({ taleId: id, status: updatedStatus })
      .then(() => {
        setData((prevData) =>
          prevData.map((item) =>
            item.ID === id ? { ...item, status: updatedStatus } : item
          )
        );
      })
      .catch((error) => console.error("Error updating tale status", error));
  };




  useEffect(()=>{
    fetchAnalytics();
  },[]);

  const fetchAnalytics=() =>{
    setLoading(true);  
    getMostPopularTales()
      .then((response) => {
        if (response.data) {
          // Update analytics state
        setAnalytics({
          totalUsersCount: response.data.totalUsersCount,
          newUsersCount: response.data.newUsersCount,
          talesCreatedCount: response.data.talesCreatedCount,
          aiAssistedTalesCount: response.data.aiAssistedTalesCount,
          aiGeneratedTalesCount: response.data.aiGeneratedTalesCount,
        });

        const formattedData = response.data.popularTales.map((tale, index) => ({
          id: index + 1,  
          ID: tale._id,
          Title: tale.title,
          Username: tale.username,
          Date: new Date(tale.createdAt).toLocaleDateString(), 
          status: 'Active', 
        }));

        setData(formattedData);
      }
    })
    .catch((error) => console.error("Error fetching users", error))
    .finally(() => setLoading(false));

  }

  const columns = [
    {
      name: 'ID',
      width: '160px',
      selector: row => row.ID,
      sortable: true,
      cell: (row) => row.ID     
    },
    {
      name: 'Title',
      width: '190px',
      selector: row => row.Title,
      sortable: true,
      cell: (row) => row.Title
    },
    {
      name: 'Username',
      width: '180px',
      selector: row => row.Username,
      sortable: true,
      cell: (row) => row.Username
    },
    {
      name: 'Date Created',
      width: '180px',
      selector: row => row.Date,
      sortable: true,
      cell: (row) => row.Date
    },
    {
      name: 'Status',
      width: '150px',
      selector: row => row.Status,
      sortable: true,
      cell: (row) => (
        <Form.Check
          type="switch"
          id={`status-switch-${row.id}`}
          checked={row.status === 'Active'}
          onChange={() => handleToggleStatus(row.ID, row.status)}
          className="status-switch"
        />
      )
    },
    {
      name: 'Actions',
      width: '150px',
      cell: row => (
        <>
          <Link className="btnview" to={`/admin/tale-detail/${row.ID}`}>
            <Icon icon="tabler:eye"></Icon>
          </Link>
        </>
      ),
    },
  ];


  const filteredData = data.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(searchText.toLowerCase()) !== -1
  );
  return (
    <React.Fragment>
      <Row className="g-3">
        <Col lg={4}>
          <div className="stats">
            <span className="statsicon"><Icon icon="tabler:users" /></span>
            <div className="stats-cont">
              <h4>Total Users</h4>
              <p>{analytics.totalUsersCount}</p>
            </div>
          </div>
        </Col>
        <Col lg={4}>
          <div className="stats">
            <span className="statsicon statsblue"><Icon icon="tabler:users"/></span>
            <div className="stats-cont">
              <h4>New Users</h4>
              <p>{analytics.newUsersCount}</p>
            </div>
          </div>
        </Col> 
        <Col lg={4}>
          <div className="stats">
            <span className="statsicon statsgreen"><Icon icon="carbon:blog"/></span>
            <div className="stats-cont">
              <h4>Tales Created</h4>
              <p>{analytics.talesCreatedCount}</p>
            </div>
          </div>
        </Col>
        <Col lg={4}>
          <div className="stats">
            <span className="statsicon"><Icon icon="carbon:blog" /></span>
            <div className="stats-cont">
              <h4>AI-Assisted Tales Created</h4>
              <p>{analytics.aiAssistedTalesCount}</p>
            </div>
          </div>
        </Col>
        <Col lg={4}>
          <div className="stats">
            <span className="statsicon statsblue"><Icon icon="carbon:blog"/></span>
            <div className="stats-cont">
              <h4>AI-Generated Tales Created</h4>
              <p>{analytics.aiGeneratedTalesCount}</p>
            </div>
          </div>
        </Col> 
      </Row>
      <Row className="mt-4">
        <Col lg={12}>
          <Card>
            <Card.Header className="py-4">
              <h5>Most Popular Tales</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                />
              </div>
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                responsive
                progressPending={loading}
                className="custom-table"
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
}
